query GetTrainingNudges(
  $page: Int
  $limit: Int
  $status: String
  $kind: String
  $employeeId: ID
) {
  trainingNudges(
    page: $page
    limit: $limit
    status: $status
    kind: $kind
    employeeId: $employeeId
  ) {
    collection {
      id
      kind
      status
      skipReason
      error
      sentOn
      sentAt
      employeeId
      employeeName
      sentByName
      summary
      items
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
